import ajaxRequest from './ajax'
import qs from "qs"


// 小程序登录
export const get_user_openid = params => {
  return ajaxRequest.get("authentication/get_user_openid?"+qs.stringify(params) )
}

// 小程序登录
export const get_access_token_by_openid = params => {
  return ajaxRequest.post("authentication/get_access_token_by_openid?",params )
}



// WEBPACK FOOTER //
// ./src/api/authentication.js